const React = require("react");
const { ThemeProvider } = require("@mui/material/styles");
const { theme, MdxProvider } = require("./src/helpers");

exports.wrapRootElement = ({ element }) => {
  return (
    <ThemeProvider theme={theme}>
      <MdxProvider>{element}</MdxProvider>
    </ThemeProvider>
  );
};
